//Stores
import { wifi_updating_devices } from 'src/stores/device-runtime/process';
import { devices_settings } from 'src/stores/device-runtime/status';
import { devices } from 'src/stores/lists/devices';
import { get } from 'svelte/store';
//Helpers
import { get_local_ip, is_gen_2, real_id } from './interface_helpers';
//Services
import { localReq, postReq } from '../services/http';
import { gen2Request } from '../services/gen_2_http_reqs';

const filterDevices = (selectedDevices, isSta1) => {
	const filteredDevices = Object.keys(selectedDevices)
		.filter((id) => {
			const settings = devices_settings.getByRealId(id);
			const isGen2 = is_gen_2(selectedDevices[id]);
			const hasSta1 = isGen2
				? typeof settings?.wifi?.sta1 !== 'undefined'
				: typeof settings?.wifi_sta1 !== 'undefined';
			return (isSta1 && hasSta1) || !isSta1;
		})
		.map((id) => (id = real_id(id)));

	return [...new Set(filteredDevices)];
};

export const batchUpdate = async (selectedDevices, WiFiConfig) => {
	filterDevices(selectedDevices, WiFiConfig.sta === 1).forEach(async (id) => {
		const device = get(devices)[real_id(id)];
		const isGen2 = is_gen_2(device);
		const isSta1 = WiFiConfig.sta === 1;
		const local_ip = get_local_ip(real_id(id));

		let res;
		if (!isGen2) {
			const postReqData: {
				id: string;
				staid: number;
				enabled: number;
				ipv4_method?: string;
				ssid?: string;
				key?: string;
				ip?: string;
				mask?: string;
				gateway?: string;
				dns?: string;
			} = {
				enabled: 1,
				ssid: WiFiConfig.ssid,
				staid: isSta1 ? 1 : 0,
				id: real_id(id),
				ip: null,
				mask: null,
				key: WiFiConfig.pass,
				ipv4_method: 'dhcp',
				dns: null,
				gateway: null,
			};
			if (local_ip) {
				delete postReqData.id;
				res = await localReq(
					selectedDevices[id],
					`${local_ip}/settings/sta`,
					'post',
					postReqData,
				);
			} else {
				res = await postReq(`/device/settings/wifi_sta`, postReqData);
			}
		} else {
			const config = {
				[isSta1 ? 'sta1' : 'sta']: {
					enable: true,
					ssid: WiFiConfig.ssid,
					is_open: WiFiConfig.isOpen,
					pass: WiFiConfig.pass,
					ipv4mode: 'dhcp',
					ip: null,
					netmask: null,
					nameserver: null,
					gw: null,
				},
			};
			res = await gen2Request(device, 'WiFi.SetConfig', { config });
		}
		if (res.isok) {
			wifi_updating_devices.update(device, isSta1 ? 1 : 0, WiFiConfig.ssid);
		}
		return res;
	});
};

export const validateWiFiCredentials = (WiFiConfig) => {
	const ssidError = WiFiConfig.ssid === '' || WiFiConfig.ssid.length > 31;
	const passError = WiFiConfig.pass.length < 8 && !WiFiConfig.isOpen;

	return ssidError || passError ? false : true;
};
